const roundDecimal = value => {
  if (typeof value === 'number') {
    return value.toFixed(2);
  }
  return value;
};

export default roundDecimal;
